import React from 'react';
import DivisorItem from "./divisor-item.jsx";
import {FaCircleInfo} from "react-icons/fa6";
import {LoadImage} from "../../get-image.jsx";

const ImageDetails = ({data, nodeId}) => {

    return (
        <>
            <div className="border-top h-[200px] bg-[#f3f3f4] rounded-t-[5px]">
                <LoadImage nodeId={nodeId}/>
            </div>
            <div>
                <p className={`text-[16px] text-white font-bold  p-2 bg-[#e68eea] mb-0`}>
                    Imagem
                </p>
                <div className={"p-2"}>
                    <DivisorItem icon={<FaCircleInfo size={18}/>} text={"Descrição"} value={data.additionalValue}/>
                </div>
            </div>
        </>
    )
};

export default ImageDetails;